import { useEffect } from 'react'

const initializeFS = () => {
  // prettier-ignore
  window.FS = window.FS || {
    event: (n, p, s) => (window.FS_Q = window.FS_Q || []).push(['event', { n, p }, s]),
    identify: (n, p, s) => {
        const q = (window.FS_Q = window.FS_Q || [])
        q.push(['user', { uid:n }, s])
        if(p) {
            q.push(['user', p, s])
        }
    },
    setVars: (n, p) => (window.FS_Q = window.FS_Q || []).push(['setVars', [n, p]]),
  }
}

export const fs = {
  sendEvent: (eventName, params) => {
    initializeFS()
    window.FS.event(eventName, params)
  },
  identify: userId => {
    initializeFS()
    window.FS.identify(userId)
  },
  setVars: (scope, params) => {
    initializeFS()
    window.FS.setVars(scope, params)
  },
}

const useFullStory = ({ route, experiment, userId, contentRichSection, contentType }) => {
  useEffect(() => {
    if (userId) fs.identify(userId)

    if (experiment?.User_Information_GAExperimentId) {
      fs.sendEvent('LD Experiment', {
        experiment_name_str: experiment.User_Information_GAExperimentId.split('.')[0],
        variation_value_str: experiment.User_Information_GAExperimentId.split('.')[1],
      })
    }
    if (!!contentRichSection) {
      fs.setVars('page', {
        pageName: route,
        content_rich_section: contentRichSection,
      })
    }
    if (!!contentType) {
      fs.setVars('page', {
        pageName: route,
        content_type: contentType,
      })
    }
  }, [route, experiment, userId, contentRichSection, contentType])
}

export default useFullStory
